import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, LogIn, ShieldCheck } from "lucide-react";
import Swal from "sweetalert2";
import "./admin-login.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://gpsapi.emedha.in/web/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem("isAdminLoggedIn", "true");
      Swal.fire({
  icon: "success",
  title: "Access Granted",
  text: "Welcome to the Geo Intelligence Portal",
  confirmButtonText: "Enter Dashboard",
  buttonsStyling: false, // Add this line
  customClass: { 
    popup: "lux-swal-popup", 
    confirmButton: "lux-swal-btn" 
  },
});
        navigate("/");
      } else {
        throw new Error(data.message || "Invalid credentials");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Auth Failed",
        text: err.message || "Connection error",
        confirmButtonText: "Try Again",
        customClass: { popup: "lux-swal-popup", confirmButton: "lux-swal-btn-error" },
      });
    }
  };

  return (
    <div className="lux-admin-page">
      <div className="lux-glass-container">
        <div className="lux-auth-card">
 <div className="lux-brand-area">
  <div className="lux-logo-container">
    <img
      src="https://allana.com/wp-content/themes/allana/assets/img/logo_allana_red.png"
      alt="Allana Logo"
      className="lux-brand-img"
    />
  </div>
  <h1 className="lux-logo">
    GEO<span className="lux-accent">ADMIN</span>
  </h1>
  <p className="lux-subtitle">Enterprise Workforce Intelligence</p>
</div>

          <form onSubmit={handleLogin} className="lux-form">
            <div className="lux-input-group">
              <Mail className="lux-input-icon" size={18} />
              <input
                type="email"
                placeholder="Administrator Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="lux-input-group">
              <Lock className="lux-input-icon" size={18} />
              <input
                type="password"
                placeholder="Secure Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button className="lux-submit-btn" type="submit">
              <span>Sign In </span>
              <LogIn size={18} />
            </button>
          </form>

          <footer className="lux-footer">
            <p>&copy; 2026 Powered by Emedha Technologies</p>
            <div className="lux-footer-line"></div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;